import React, { Component, lazy, Suspense } from "react";

import { Card, Row, Col } from "react-bootstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { connect } from "react-redux";
import "./Dashboard.css";
import { dashboardList } from "../../containers/DefaultLayout/action";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.dashboardList();
  }

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  render() {
    const data =
      this.props.dashboardDtlsList && this.props.dashboardDtlsList
        ? this.props.dashboardDtlsList && this.props.dashboardDtlsList
        : null;

    return (
      <div className="animated fadeIn">
        <div className="dashboardsecsectin">
          <Row>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link
                to="/patientusers/patientsprofile"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="dashboardprjectfrst">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconspatients">
                      <div className="projecticons">
                        <i className="fa fa-users fa-lg font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.patient
                            : 0}{" "}
                          <br />
                          Patients
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>

            <Col sm={12} xs={12} md={3} lg={3}>
              <Link
                to="/chemistuser/chemistprofile"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="dashboardcountfrst">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconschemist">
                      <div className="iconscounticons">
                        <i className="fa fa-users fa-lg  font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.chemist
                            : 0}
                          <br />
                          Chemists
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link to="/distributors" onClick={() => window.scrollTo(0, 0)}>
                <div className="dashboardprogressfrst">
                  <Row className="dashboardcountrow">
                    <Col
                      sm={3}
                      xs={3}
                      md={3}
                      lg={3}
                      className="iconsdistributor"
                    >
                      <div className="iconsprogrsicons">
                        <i className="fa fa-users fa-lg font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.distributor
                            : 0}
                          <br />
                          Distributors
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <div className="dashboardpendingfrst">
                <Row className="dashboardcountrow">
                  <Col
                    sm={3}
                    xs={3}
                    md={3}
                    lg={3}
                    className="iconsadvertisement"
                  >
                    <div className="iconspendingicons">
                      <i className="cui-briefcase icons font-2xl d-block mt-4 iconsettings" />
                    </div>
                  </Col>
                  <Col sm={9} xs={9} md={9} lg={9}>
                    <div>
                      <p className="dashprojctpera">
                        0
                        <br />
                        Advertisements
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
        {/* ============================================================================= */}
        <div className="dashboardthdsectin">
          <Row>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link
                to="/patientusers/patientorder"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="dashboardprject">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconsship">
                      <div className="iconsshipicons">
                        <i className="nav-icon nav-icon fa fa-circle-o-notch font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.patientOrder
                            : 0}{" "}
                          <br />
                          Patient Orders
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link
                to="/patientusers/patientInvoice"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="dashboardcount">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconsdoc">
                      <div className="iconsdocicons">
                        <i className="nav-icon fa fa-credit-card custom font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.patientInvoice
                            : 0}{" "}
                          <br />
                          Patient Invoices
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link
                to="/chemistuser/chemistorders"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="dashboardprogress">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconsdeftn">
                      <div className="iconsdeftnicons">
                        <i className="nav-icon nav-icon fa fa-circle-o-notch font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.chemistOrder
                            : 0}{" "}
                          <br />
                          Chemist Orders
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link
                to="/chemistuser/chemistInvoice"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="dashboardprogress">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconsdelast">
                      <div className="iconsdelasticons">
                        <i className="nav-icon fa fa-credit-card font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.chemistInvoice
                            : 0}{" "}
                          <br />
                          Chemist Invoices
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
          </Row>
        </div>
        {/* ====================================================================== */}
        <div className="dashboardsecsectin">
          <Row>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link to="/productreturns" onClick={() => window.scrollTo(0, 0)}>
                <div className="dashboardprject">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconsproject">
                      <div className="projection">
                        <i className="cui-action-undo font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.productReturn
                            : 0}
                          <br />
                          Product Returns
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link to="/expiryreturns" onClick={() => window.scrollTo(0, 0)}>
                <div className="dashboardprject">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconsproject">
                      <div className="projection">
                        <i className="cui-calendar font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.expiryReturn
                            : 0}
                          <br />
                          Expiry Returns
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>

            <Col sm={12} xs={12} md={3} lg={3}>
              <Link to="/creditnotes" onClick={() => window.scrollTo(0, 0)}>
                <div className="dashboardcount">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconscount">
                      <div className="iconscounticons">
                        <i className="cui-calculator icons font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          {data !== null && data !== undefined
                            ? data.creditNotes
                            : 0}
                          <br />
                          Credit Notes
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <Link
                to="/platformearnings"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="dashboardprogress">
                  <Row className="dashboardcountrow">
                    <Col sm={3} xs={3} md={3} lg={3} className="iconsprogrs">
                      <div className="iconsprogrsicons">
                        <i className="nav-icon fa fa-credit-card font-2xl d-block mt-4 iconsettings" />
                      </div>
                    </Col>
                    <Col sm={9} xs={9} md={9} lg={9}>
                      <div>
                        <p className="dashprojctpera">
                          0
                          <br />
                          Total Revenue
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Link>
            </Col>
            <Col sm={12} xs={12} md={3} lg={3}>
              <div className="dashboardpending">
                <Row className="dashboardcountrow">
                  <Col sm={3} xs={3} md={3} lg={3} className="iconspending">
                    <div className="iconspendingicons">
                      <i className="nav-icon fa fa-credit-card font-2xl d-block mt-4 iconsettings" />
                    </div>
                  </Col>
                  <Col sm={9} xs={9} md={9} lg={9}>
                    <div>
                      <p className="dashprojctpera">
                        0
                        <br />
                        Total Tax
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function bindAction(dispatch) {
  return {
    dashboardList: () => {
      dispatch(dashboardList());
    },
  };
}

const mapStateToProps = (state) => ({
  dashboardDtlsList: state.DashboardReducer.dashboardDtlsList,
});

export default connect(mapStateToProps, bindAction)(Dashboard);

// import React, { Component } from "react";
// import { connect } from "react-redux";
// import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
// import {
//   People,
//   LocalPharmacy,
//   Storefront,
//   Work,
//   LocalShipping,
//   ReceiptLong,
//   ShoppingCart,
//   CreditCard,
//   Replay,
//   Calculate,
//   MonetizationOn,
//   AccountBalance,
// } from "@mui/icons-material";
// import { Link } from "react-router-dom";
// import { dashboardList } from "../../containers/DefaultLayout/action";

// class Dashboard extends Component {
//   componentDidMount() {
//     this.props.dashboardList();
//   }

//   render() {
//     const data = this.props.dashboardDtlsList || {};

//     const cards = [
//       {
//         title: "Patients",
//         count: data.patient || 0,
//         icon: <People fontSize="large" color="primary" />,
//         link: "/patientusers/patientsprofile",
//       },
//       {
//         title: "Chemists",
//         count: data.chemist || 0,
//         icon: <LocalPharmacy fontSize="large" color="secondary" />,
//         link: "/chemistuser/chemistprofile",
//       },
//       {
//         title: "Distributors",
//         count: data.distributor || 0,
//         icon: <Storefront fontSize="large" sx={{ color: "#0288d1" }} />,
//         link: "/distributors",
//       },
//       {
//         title: "Advertisements",
//         count: 0,
//         icon: <Work fontSize="large" sx={{ color: "#6d4c41" }} />,
//       },
//       {
//         title: "Patient Orders",
//         count: data.patientOrder || 0,
//         icon: <ShoppingCart fontSize="large" color="primary" />,
//         link: "/patientusers/patientorder",
//       },
//       {
//         title: "Patient Invoices",
//         count: data.patientInvoice || 0,
//         icon: <ReceiptLong fontSize="large" color="secondary" />,
//         link: "/patientusers/patientInvoice",
//       },
//       {
//         title: "Chemist Orders",
//         count: data.chemistOrder || 0,
//         icon: <LocalShipping fontSize="large" sx={{ color: "#43a047" }} />,
//         link: "/chemistuser/chemistorders",
//       },
//       {
//         title: "Chemist Invoices",
//         count: data.chemistInvoice || 0,
//         icon: <CreditCard fontSize="large" sx={{ color: "#f57c00" }} />,
//         link: "/chemistuser/chemistInvoice",
//       },
//       {
//         title: "Product Returns",
//         count: data.productReturn || 0,
//         icon: <Replay fontSize="large" color="primary" />,
//         link: "/productreturns",
//       },
//       {
//         title: "Credit Notes",
//         count: data.creditNotes || 0,
//         icon: <Calculate fontSize="large" color="secondary" />,
//         link: "/creditnotes",
//       },
//       {
//         title: "Total Revenue",
//         count: 0,
//         icon: <MonetizationOn fontSize="large" sx={{ color: "#2e7d32" }} />,
//         link: "/platformearnings",
//       },
//       {
//         title: "Total Tax",
//         count: 0,
//         icon: <AccountBalance fontSize="large" sx={{ color: "#c62828" }} />,
//       },
//     ];

//     return (
//       <Box sx={{ p: 3 }}>
//         <Grid container spacing={3}>
//           {cards.map((card, index) => {
//             const CardInner = (
//               <Card
//                 key={index}
//                 sx={{
//                   p: 1,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   borderRadius: 3,
//                   boxShadow: "none",
//                   transition: "all 0.3s ease",
//                   "&:hover": {
//                     boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
//                     transform: "translateY(-3px)",
//                   },
//                 }}
//               >
//                 <CardContent sx={{ flexGrow: 1 }}>
//                   <Typography
//                     variant="h4"
//                     sx={{ fontWeight: 600, color: "#212121" }}
//                   >
//                     {card.count}
//                   </Typography>
//                   <Typography
//                     variant="subtitle1"
//                     color="text.secondary"
//                     sx={{ mt: 0.5 }}
//                   >
//                     {card.title}
//                   </Typography>
//                 </CardContent>
//                 <Box sx={{ mr: 2 }}>{card.icon}</Box>
//               </Card>
//             );

//             return (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 {card.link ? (
//                   <Link
//                     to={card.link}
//                     style={{ textDecoration: "none", color: "inherit" }}
//                     onClick={() => window.scrollTo(0, 0)}
//                   >
//                     {CardInner}
//                   </Link>
//                 ) : (
//                   CardInner
//                 )}
//               </Grid>
//             );
//           })}
//         </Grid>
//       </Box>
//     );
//   }
// }

// function bindAction(dispatch) {
//   return {
//     dashboardList: () => {
//       dispatch(dashboardList());
//     },
//   };
// }

// const mapStateToProps = (state) => ({
//   dashboardDtlsList: state.DashboardReducer.dashboardDtlsList,
// });

// export default connect(mapStateToProps, bindAction)(Dashboard);
